import { ROUTES } from '@/utils/constants';

export const LEGACY_DOMAIN_STEP_ALIASES = Object.freeze({
  setup: 'domain',
  overview: 'domain',
  domain: 'domain',
  categories: 'event',
  events: 'event',
  values: 'event',
  consequences: 'action',
  'consequence-types': 'action',
  actions: 'action',
  stickers: 'action',
  awards: 'action',
  rules: 'rules',
  'discipline-rules': 'rules',
  reports: 'reports',
});

export const LEGACY_DOMAIN_EDITOR_ROUTES = Object.freeze([
  { path: ROUTES.DISCIPLINE_RULES, domain: 'discipline', step: 'rules' },
  { path: ROUTES.RULES, domain: 'discipline', step: 'rules' },
  { path: ROUTES.OFFENCES, domain: 'discipline', step: 'event' },
  { path: ROUTES.CONSEQUENCE_TYPES, domain: 'discipline', step: 'action' },
  { path: '/values', domain: 'recognition', step: 'event' },
  { path: ROUTES.STICKERS, domain: 'recognition', step: 'action' },
  { path: ROUTES.AWARDS, domain: 'recognition', step: 'action' },
  {
    path: `${ROUTES.AWARDS}/new`,
    domain: 'recognition',
    step: 'action',
    extraParams: { editor: 'award', award: 'new' },
  },
  {
    path: `${ROUTES.AWARDS}/edit/:awardId`,
    domain: 'recognition',
    step: 'action',
    pathParam: 'awardId',
    queryParam: 'award',
    extraParams: { editor: 'award' },
  },
  { path: '/weekly-summary-settings', domain: 'recognition', step: 'reports' },
]);

export const LEGACY_SETUP_BEHAVIOUR_TABS = Object.freeze({
  values: { domain: 'recognition', step: 'event' },
  stickers: { domain: 'recognition', step: 'action' },
  awards: { domain: 'recognition', step: 'action' },
  categories: { domain: 'discipline', step: 'event' },
  events: { domain: 'discipline', step: 'event' },
  consequences: { domain: 'discipline', step: 'action' },
  actions: { domain: 'discipline', step: 'action' },
  rules: { domain: 'discipline', step: 'rules' },
  reports: { domain: 'discipline', step: 'reports' },
  'consequence-types': { domain: 'discipline', step: 'action' },
  'discipline-rules': { domain: 'discipline', step: 'rules' },
});

export function buildDomainEditorDestination(
  { search = '', hash = '' } = {},
  { domain, step, extraParams = {} } = {},
) {
  const params = new URLSearchParams(search);
  const legacyTab = params.get('tab');
  const requestedStep = step
    || LEGACY_DOMAIN_STEP_ALIASES[params.get('step')]
    || LEGACY_DOMAIN_STEP_ALIASES[legacyTab];

  params.delete('tab');
  // `create=1` belongs exclusively to the New Domain wizard. Legacy editor
  // links must never open that wizard by accident.
  params.delete('create');

  if (domain) params.set('domain', domain);
  if (requestedStep) params.set('step', requestedStep);
  Object.entries(extraParams).forEach(([key, value]) => {
    if (value === null || value === undefined || value === false || value === '') {
      params.delete(key);
    } else {
      params.set(key, String(value));
    }
  });

  const query = params.toString();
  return `${ROUTES.DOMAINS}${query ? `?${query}` : ''}${hash}`;
}

export function domainEditorPath(domain, step, extraParams = {}) {
  return buildDomainEditorDestination({}, { domain, step, extraParams });
}

export function setupBehaviourDestination(location) {
  const tab = new URLSearchParams(location?.search || '').get('tab');
  return buildDomainEditorDestination(
    location,
    LEGACY_SETUP_BEHAVIOUR_TABS[tab] || { domain: 'discipline', step: 'domain' },
  );
}
